import "@/assets/sass/announcement.scss";
import { useEffect, useState } from "react";
import { Modal } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
const NextIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.1332 7.98372L5.0332 4.88372L6.26654 3.65039L10.5999 7.98372L6.26654 12.3171L5.0332 11.0837L8.1332 7.98372Z"
      fill="#576059"
    />
  </svg>
);
export default function Announcement() {
  const [modal, contextModalHolder] = Modal.useModal();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const pathname = location.pathname;
  const links = [
    {
      link: "/announcement",
      includes: ["/announcement", "/announcement/notice-detail"],
      label: t("announcement.news_title"),
    },
    {
      link: "/announcement/reference",
      includes: ["/announcement/reference", "/announcement/reference-detail"],
      label: t("announcement.resources"),
    },
    {
      link: "/announcement/faq",
      includes: ["/announcement/faq"],
      label: "FAQ",
    },
  ];
  return (
    <div className="announcement-page">
      {contextModalHolder}
      <section
        className="cs-page_head cs-bg"
        style={{
          backgroundImage: "url(/assets/img/bg_news.png)",
          height: "338px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div className="container">
          <div className="text-center">
            <h1
              className="cs-page_title gmarket"
              style={{
                position: "relative",
                fontSize: 40,
                color: "white",
                fontWeight: "bold",
                "text-transform": "uppercase",
              }}
            >
              {t("announcement.news_title")}
            </h1>
          </div>
        </div>
      </section>
      <div className="announcement-container container">
        
        <div className="navs-menus">
          <div className="title">{t("announcement.customer_support")}</div>
          <ul className="navs-list">
            {links.map((item) => (
              <li
                key={item.link}
                className={
                  "navs-item " +
                  (item.includes.includes(pathname) ? "active" : "")
                }
                onClick={() => navigate(item.link)}
              >
                <div className="navs-label">
                  <span>{item.label}</span>
                  <NextIcon />
                </div>
              </li>
            ))}
          </ul>
        </div>
        
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
